import { DynamicIcon, IconName } from "lucide-react/dynamic";

interface HeaderWithIconProps {
  icon?: IconName;
  title: string;
}

export const HeaderWithIcon = ({ icon, title }: HeaderWithIconProps) => {
  return (
    <div className="flex items-center">
      {icon && <DynamicIcon name={icon} size={16} />}
      <div className="ml-2.5 flex items-center text-xs font-medium leading-none tracking-wide uppercase opacity-80">
        <span className="translate-y-px">{title}</span>
      </div>
    </div>
  );
};
